export default __webpack_public_path__ + "static/media/outdoor_lamp_banners_reduced.0ebc96da.jpg";